"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = errorFactory;
var _constants = require("../constants");
var _language = require("../utils/language.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _first2 = _interopRequireDefault(require("lodash/first"));
/**
 * create error object
 * @param {Object} error
 * @returns {Object}
 */
function errorFactory(_ref) {
  var error = _ref.error,
    language = _ref.language,
    fallBackErrorCode = _ref.fallBackErrorCode;
  var response = (0, _get2["default"])(error, 'response.data', null);
  var errorCode = (0, _first2["default"])((0, _get2["default"])(response, 'errorCodes', [])) || fallBackErrorCode;
  var erorrDetails = (0, _get2["default"])(_constants.ERRORS_HASHMAP, "".concat(errorCode), null);
  if (!erorrDetails) {
    return error;
  }
  return {
    apiCode: errorCode,
    errorCode: (0, _get2["default"])(erorrDetails, 'errorCode', null),
    statusCode: (0, _get2["default"])(erorrDetails, 'statusCode', null),
    action: (0, _language.translate2keysLabel)(erorrDetails, 'description', language),
    title: (0, _language.translate2keysLabel)(erorrDetails, 'title', language),
    bodyText: (0, _language.translate2keysLabel)(erorrDetails, 'bodyText', language),
    primaryActionLabel: (0, _language.translate2keysLabel)(erorrDetails, 'primaryActionLabel', language),
    secondaryActionLabel: (0, _language.translate2keysLabel)(erorrDetails, 'secondaryActionLabel', language),
    itShould: (0, _get2["default"])(erorrDetails, 'itShould', null),
    error: error
  };
}